module.exports = __webpack_public_path__ + "static/media/close-icon.df64088b.svg";